export const DEPENDENTS_ADD = 'DEPENDENTS_ADD' as const;
export const DEPENDENTS_LOADING = 'DEPENDENTS_LOADING' as const;
export const DEPENDENTS_LOADED = 'DEPENDENTS_LOADED' as const;
export const DEPENDENTS_ADD_ONE = 'DEPENDENTS_ADD_ONE' as const;
export const DEPENDENT_UPDATE = 'DEPENDENT_UPDATE' as const;
export const DEPENDENT_DETAILED = 'DEPENDENT_DETAILED' as const;
export const DEPENDENT_RESET = 'DEPENDENT_RESET' as const;
export const DEPENDENTS_FAILURE = 'DEPENDENTS_FAILURE' as const;
export const DEPENDENT_REQUESTS_LOADING = 'DEPENDENT_REQUESTS_LOADING' as const;
export const DEPENDENT_REQUESTS_LOADED = 'DEPENDENT_REQUESTS_LOADED' as const;
export const DEPENDENT_REQUESTS_FAILURE = 'DEPENDENT_REQUESTS_FAILURE' as const;
export const DEPENDENT_REQUESTS_TOTAL_PAGE = 'DEPENDENT_REQUESTS_TOTAL_PAGE' as const;
export const DEPENDENT_REQUESTS_RESET = 'DEPENDENT_REQUESTS_RESET' as const;
export const RESET_ERROR = 'RESET_ERROR' as const;
